import { MessageSquare } from "lucide-react";
import { SectionHeading, LinkRowButton } from "./tips-primitives";

/**
 * AskSpotterSection — list of suggested Spotter prompts.
 * Sentence case copy; triggers `askSpotter()` via the `onAsk` callback.
 */
export function AskSpotterSection({
  suggestions,
  onAsk,
}: {
  suggestions: string[];
  onAsk: (question: string) => void;
}) {
  if (suggestions.length === 0) return null;
  return (
    <div className="space-y-2.5">
      <SectionHeading icon={MessageSquare}>Ask Spotter</SectionHeading>
      <p className="font-sans text-[12px] text-muted-foreground">
        Get help from your ai assistant.
      </p>
      <div className="flex flex-col gap-1.5">
        {suggestions.map((suggestion, index) => (
          <LinkRowButton key={index} onClick={() => onAsk(suggestion)}>
            {suggestion}
          </LinkRowButton>
        ))}
      </div>
    </div>
  );
}
